import { Link, useNavigate } from 'react-router-dom';

export default function PricingFooter() {
  const navigate = useNavigate();

  const handleNavClick = (sectionId: string) => {
    navigate('/');
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <footer className="relative py-8 sm:py-12 bg-[#f5f0e8] border-t border-[#e8dcc8]">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 sm:gap-6">
          <p className="text-[#71717a] text-xs sm:text-sm text-center sm:text-left">
            © 2026 HushLegal •{' '}
            <a
              href="mailto:sales@hushlegal.com"
              className="hover:text-[#8B4513] transition-colors cursor-pointer"
            >
              sales@hushlegal.com
            </a>
          </p>
          <div className="flex items-center gap-4 sm:gap-6">
            <Link
              to="/privacy"
              className="text-[#71717a] hover:text-[#8B4513] text-xs sm:text-sm transition-colors cursor-pointer whitespace-nowrap"
            >
              Privacy
            </Link>
            <button
              onClick={() => handleNavClick('home')}
              className="text-[#71717a] hover:text-[#8B4513] text-xs sm:text-sm transition-colors cursor-pointer whitespace-nowrap"
            >
              Terms
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
